import { Navigate, useLocation } from 'react-router-dom';

export const PrivateRoutes = ({ children, isAuth }) => {

    const location = useLocation();
    const currentPath = location?.pathname ? location?.pathname : '/inicio'

    if (isAuth && currentPath === '/') {
        return <Navigate to="/inicio" replace />
    }

    return isAuth ? children : <Navigate to="/login" state={{ from: currentPath }} />
}
